import Box from '@mui/material/Box';
import type { Category } from './Categories';
import { ChartLegendItem } from './ChartLegendItem';

interface ChartLegendProps {
  data: Category[];
}

export function ChartLegend({ data }: ChartLegendProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 60,
        alignSelf: 'start',
        width: '100%',
      }}
    >
      {data.map((item, index) => (
        <ChartLegendItem key={item.label} item={item} index={index} />
      ))}
    </Box>
  );
}
